<template>
  <div class="zssk-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="审核状态">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="未审核" :value="0" />
                <el-option label="已审核" :value="1" />
                <el-option label="审核拒绝" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="客户名称"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.clientname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="退款类型"
                    width="80"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.type===0">意向金</span>
                      <span v-if="scope.row.type===1">样品预存款</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="退款金额"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.money}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请人"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.username}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="审核状态"
                    width="120"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1" type="warning">待审核</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2">已审核</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===4" type="danger">审核拒绝</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="refundrson"
                    label="退款原因"
                    min-width="120"
                    show-overflow-tooltip>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="退款审核"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="fullscreenLoading">
        <tr>
          <th>申请人</th>
          <td>{{ eidtList.username }}</td>
          <th>申请日期</th>
          <td>{{ eidtList.time }}</td>
        </tr>
        <tr>
          <th>客户姓名</th>
          <td><el-button type="text" size="small" icon="el-icon-s-custom" @click="$refs['clientInfo'].openClientDetails(eidtList.cid)">{{ eidtList.clientname }}</el-button></td>
          <th>联系电话</th>
          <td>{{ eidtList.tel }}</td>
        </tr>
        <tr>
          <th>退款类型</th>
          <td>
            <span v-if="eidtList.type===0">意向金</span>
            <span v-if="eidtList.type===1">样品预存款</span>
          </td>
          <th>退款原因</th>
          <td>{{eidtList.refundrson}}</td>
        </tr>
        <tr>
          <th>退款金额</th>
          <td style="color: #409EFF;font-weight: bold">{{ eidtList.money }}</td>
          <th>收款人</th>
          <td>{{ eidtList.name }}</td>
        </tr>
        <tr>
          <th>收款卡号</th>
          <td>{{ eidtList.card }}</td>
          <th>开户行</th>
          <td>{{ eidtList.bank }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ eidtList.remark }}</td>
        </tr>
        <tr>
          <th>招商总监</th>
          <td>{{ eidtList.dirname }}</td>
          <th>审核时间</th>
          <td>{{ eidtList.dirtime }}</td>
        </tr>
        <tr  v-if="eidtList.mark===2">
          <th>财务审核</th>
          <td>{{ eidtList.auditname }}</td>
          <th>审核时间</th>
          <td>{{ eidtList.audittime }}</td>
        </tr>
        <tr v-if="eidtList.mark===4">
          <th>财务驳回原因</th>
          <td colspan="3" style="color:#f56c6c">{{ eidtList.rson }}</td>
        </tr>
        <tr v-if="eidtList.mark===0&&eidtList.rson!=''&&eidtList.rson!=null">
          <th>上次驳回</th>
          <td colspan="3" style="color:#f56c6c">{{ eidtList.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="eidtList.mark===1" :loading="auditLoading" size="small" @click="audit(1)">审核通过</el-button>
        <el-button type="danger" v-if="eidtList.mark===1" :loading="auditLoading" size="small" @click="audit(0)">审核驳回</el-button>
        <el-button size="small" @click="editVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <ClientInfo ref="clientInfo"></ClientInfo>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getClientRefundListByCw,
  getClientRefundDetail,
  checkClientRefundByCw
} from '@/api/work'
import ClientInfo from '@/components/ClientInfo'
export default {
  name: 'zstkshcw',
  computed: {
    user: getUser
  },
  components: {
    ClientInfo
  },
  data() {
    return {
      fullscreenLoading: false,
      searchForm: {
        search: '',
        type: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      eidtList: [],
      imgSrcList: [],
      checkid: '',
      auditLoading: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search != null && this.searchForm.search.trim() != '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        mark: this.searchForm.type,
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid
      }
      getClientRefundListByCw(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.imgSrcList = []
      this.checkid = ''
      this.editVisible = true
      this.fullscreenLoading = true
      getClientRefundDetail({ crid: row.crid }).then(response => {
        this.fullscreenLoading = false
        this.eidtList = response.data
        this.checkid = this.eidtList.crid
      }).catch(() => {
        this.fullscreenLoading = false
      })
    },
    audit(n) {
      if (this.auditLoading) {
        return false
      }
      if (n === 0) {
        this.$prompt('请输入驳回原因', '审核驳回-招商退款审核', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '驳回原因不可为空'
        }).then(({ value }) => {
          this.auditLoading = true
          checkClientRefundByCw({ userid: this.user.dUserid, crid: this.checkid, ispass: n, reason: value }).then(response => {
            this.auditLoading = false
            this.editVisible = false
            this.$message({
              message: '意向金确认单审核已驳回',
              type: 'success'
            })
            this.getData()
          }).catch(() => {
            this.auditLoading = false
          })
        }).catch(() => {})
      } else {
        this.$confirm('此操作将通过此次招商退款审核?', '审核通过-招商退款审核', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auditLoading = true
          checkClientRefundByCw({ userid: this.user.dUserid, crid: this.checkid, ispass: n }).then(response => {
            this.auditLoading = false
            this.editVisible = false
            this.$message({
              message: '意向金确认单审核已通过',
              type: 'success'
            })
            this.getData()
          }).catch(() => {
            this.auditLoading = false
          })
        }).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.zssk-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
